import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './BranchSelector.css';

// A native <select> was used here before, but a browser's own dropdown
// popup can't be given a max-height/scrollbar via CSS - with a long branch
// list it just grows past the screen. This renders the options in our own
// panel instead, so a scroller can be applied to it directly.
const BranchSelector = ({ officerProfile, secondaryBranches, allActiveBranches, value, onChange }) => {
    const isHOUser = ["HO"].includes(officerProfile?.branch?.branch_code);
    const hasPrimarySecondaryBranches = ["RO", "BM", "BCM"].includes(officerProfile?.roleMaster?.short_name);
    const isDisabled = !isHOUser && !hasPrimarySecondaryBranches;

    const options = isHOUser ?
                        allActiveBranches?.map((branch) => {
                            return {
                                key: branch.branch_code,
                                value: branch.branch_code,
                                label: `${branch.branch_name} - ${branch.branch_code}`
                            }
                        }) :
                    hasPrimarySecondaryBranches ?
                        [
                            ...(secondaryBranches || [])?.map((branch) => {
                                return {
                                    key: branch.branch_code,
                                    value: branch.branch_code,
                                    label: `${branch.branch_name} - ${branch.branch_code} (S)`
                                }
                            }),
                            {
                                key: officerProfile?.branch?.branch_code,
                                value: officerProfile?.branch?.branch_code,
                                label: `${officerProfile?.branch?.branch_name} - ${officerProfile?.branch?.branch_code} (P)`
                            }
                        ] :
                        [{
                            key: officerProfile?.branch?.branch_code,
                            value: officerProfile?.branch?.branch_code,
                            label: `${officerProfile?.branch?.branch_name} - ${officerProfile?.branch?.branch_code}`
                        }];

    const allOptions = [{ key: "all", value: "", label: "All branches" }, ...(options || [])];
    const selectedOption = allOptions.find((option) => option.value === value) || allOptions[0];

    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectOption = (optionValue) => {
        setIsOpen(false);
        // Matches the native <select>'s onChange(e) => e.target.value contract
        // so callers don't need to change.
        onChange?.({ target: { value: optionValue } });
    };

    return (
        <div className="team-overview-branch-select-container" ref={containerRef}>
            <button
                type="button"
                className="team-overview-branch-select"
                disabled={isDisabled}
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <span className="team-overview-branch-select-label">{selectedOption.label}</span>
                <FontAwesomeIcon icon={faChevronDown} className="team-overview-branch-select-caret" />
            </button>

            {isOpen && !isDisabled && (
                <div className="team-overview-branch-select-panel">
                    {allOptions.map((option) => (
                        <div
                            key={option.key}
                            className={`team-overview-branch-select-option ${option.value === value ? 'selected' : ''}`}
                            onClick={() => selectOption(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BranchSelector;
